<template>
  <div>
    <Card>
      <TablePaginate
        :columns="columns"
        :data="bills"
        :loading="loading"
        :meta="meta"
        :changePage="changePage"
      ></TablePaginate>
    </Card>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import TablePaginate from '@/components/TablePaginate'
import { podStatus, paymentChinese } from '@/libs/table-render'

export default {
  components: {
    TablePaginate
  },
  data () {
    return {
      id: this.$route.params.id,
      columns: [
        {
          title: 'ID',
          key: 'id',
          width: 80,
          align: 'center'
        },
        {
          title: '创建时间',
          key: 'created_at_str',
          width: 180,
          align: 'center'
        },
        {
          title: '订单号',
          key: 'code',
          width: 180,
          align: 'center'
        },
        {
          title: '支付状态',
          key: 'status',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return paymentChinese(h, params.row.status)
          }
        },
        {
          title: '付款方式',
          key: 'payment_method',
          width: 120,
          align: 'center',
          render: (h, params) => {
            return podStatus(h, params.row.payment_method)
          }
        },
        {
          title: '会员名称',
          key: 'fresh_customer_username',
          width: 180,
          align: 'center'
        },
        {
          title: '会员手机',
          key: 'fresh_customer_mobile',
          width: 180,
          align: 'center'
        },
        {
          title: '充值金额',
          key: 'amount',
          width: 100,
          align: 'center'
        },
        {
          title: '赠送金额',
          key: 'give',
          width: 100,
          align: 'center'
        }
      ]
    }
  },
  created () {
    this.resetQuery()
    this.index({ customer_id: this.id })
  },
  computed: {
    ...mapGetters('bill', ['bills', 'meta', 'loading'])
  },
  methods: {
    ...mapActions('bill', ['index']),
    ...mapMutations('bill', ['changeQuery', 'resetQuery']),
    changePage (page) {
      this.changeQuery({ customer_id: this.id, page })
      this.index()
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="less">
.filter-container {
  padding-bottom: 10px;
  .filter-item {
    display: inline-block;
    vertical-align: middle;
    margin-bottom: 10px;
  }
}
</style>
